module.exports = __webpack_public_path__ + "img/kfll.a554f828.png";